import axiosInstance from "./axiosInstance";

export const LoginAdmin = async (payload) => {
    try {
        const response = await axiosInstance.post('/auths/login', payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetCurrentUser = async (id) => {
    try {
        const response = await axiosInstance.get(`/users/${id}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
}

export const ForgotPass = async (payload) => {
    try {
        const response = await axiosInstance.post('/auths/forgotPassword', payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const VerifyOTP = async (payload) => {
    try {
        const response = await axiosInstance.post('/auths/verify', payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const ResetPass = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/auths/resetPassword/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const UpdateProfile = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/users/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const ChangePass = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/auths/updatePassword/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetClients = async params => {
    try {
        const response = await axiosInstance.get(`/users?${params}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const UpdateClient = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/users/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const DeleteClient = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/users/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


export const BulkDeleteClient = async (payload) => {
    try {
        const response = await axiosInstance.post('/users/bulkDelete', payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviders = async (params) => {
    try {
        const response = await axiosInstance.get(`/businessProfiles?${params}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderById = async (id) => {
    try {
        const response = await axiosInstance.get(`/businessProfiles/${id}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const UpdateServiceProvider = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/businessProfiles/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const DeleteServiceProvider = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/businessProfiles/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderReviews = async (id, filters) => {
    try {
        let queryString = `businessProfileId=${id}`;
        const response = await axiosInstance.get(`/reviews?${queryString}&${filters}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderRating = async (payload) => {
    try {
        const response = await axiosInstance.post('/reviews/providerTotalRating', payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderCategories = async (id) => {
    try {
        const response = await axiosInstance.get(`/subCategories?businessProfileId=${id}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderGallery = async (id, filters) => {
    try {
        let queryString = `businessProfileId=${id}`;
        const response = await axiosInstance.get(`/providerGalleries?${queryString}&${filters}&serverPaging=false`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const DeleteServiceProviderGallery = async (payload) => {
    try {
        const response = await axiosInstance.post(`/providerGalleries/deletedProviderImage`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

// export const UploadServiceProviderGallery = async (payload, onUploadProgress) => {
//     try {
//         const response = await axiosInstance.post('/images/upload', payload, { onUploadProgress: onUploadProgress });
//         return response.data;
//     } catch (error) {
//         return error.response;
//     }
// };

export const UpdateServiceProviderReviews = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/reviews/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetServiceProviderServiceList = async (id) => {
    try {
        const response = await axiosInstance.get(`/providerServices/providersub/services?businessProfileId=${id}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const DeleteServiceProviderService = async (id) => {
    try {
        const response = await axiosInstance.delete(`/providerSubServices/${id}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


export const GetAllReviews = async (filter) => {
    try {
        const response = await axiosInstance.get(`/reviews?${filter}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};





// Dashboard

export const GetDashboardData = async (filter) => {
    try {
        const response = await axiosInstance.get(`/users/adminDashBoard/AllData?${filter}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


// SearchList

export const GetSearchList = async (filter) => {
    try {
        const response = await axiosInstance.get(`/searchLists?${filter}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};
export const DeleteSearchListItem = async (payload, id) => {
    try {
        const response = await axiosInstance.put(`/searchLists/${id}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};



// Support tickets

export const GetSupportTickets = async (params) => {
    try {
        const response = await axiosInstance.get(`/reportProblems?${params}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


export const UpdateSupportTicket = async (payload, ticketId) => {
    try {
        const response = await axiosInstance.put(`/reportProblems/${ticketId}`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};



// Notifications

export const GetNotifications = async (params) => {
    try {
        const response = await axiosInstance.get(`/userNotifications?${params}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};

export const GetNotificationsCount = async (params) => {
    try {
        const response = await axiosInstance.get(`/userNotifications/unRead/count?${params}`);
        return response?.data;
    } catch (error) {
        return error.response;
    }
};


export const SendNotification = async (payload) => {
    try {
        const response = await axiosInstance.post(`/userNotifications/adminNotification`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


export const ClearNotifications = async (payload) => {
    try {
        const response = await axiosInstance.post(`/userNotifications/clear/Notification/admin`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
};


// Templates

export const GetTemplates = async (params) => {
    try {
        const response = await axiosInstance.get(`/templates?${params}&serverPaging=false`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};



// Get Clients 



export const GetClientsList = async () => {
    try {
        const response = await axiosInstance.get(`/users/getAll/ClientList`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};
export const GetProvidersList = async () => {
    try {
        const response = await axiosInstance.get(`/users/getAll/ProviderList`);
        return response.data;
    } catch (error) {
        return error.response;
    }
};





// Mailing

export const SendEmail = async (payload) => {
    try {
        const response = await axiosInstance.post(`/users/userMail`, payload);
        return response.data;
    } catch (error) {
        return error.response;
    }
}



// Images Upload

// export const UploadImage = async (payload) => {
//     try {
//         const response = await axiosInstance.post('/images/upload', payload);
//         return response.data;
//     } catch (error) {
//         return error.response;
//     }
// };

export const UploadImage = async (payload, onUploadProgress) => {
    try {
        const response = await axiosInstance.post('/images/upload', payload, { onUploadProgress: onUploadProgress });
        return response.data;
    } catch (error) {
        return error.response;
    }
};

